import PropTypes from 'prop-types'
import { View } from './View'

/**
 * Appkit4 Buttonコンポーネントは
 * <a href="https://appkit.pwc.com/appkit4/content/button?version=react&variation=primary" target="_blank">こちら</a>
 */
export const Button = ({ ...props }) => {
    return <View {...props} />
}

Button.propTypes = {
    /**
     * コンテンツテキスト
     */
    label: PropTypes.string,
    /**
     * 種類<br>
     * [primary] 背景に色あり<br>
     * [secondary] ボーダーのみあり<br>
     * [text] 背景もボーダーもなし
     */
    kind: PropTypes.oneOf(['primary', 'secondary', 'text']),
    /**
     * ボタンサイズ<br>
     * [xl] font-size: 16px, height: 54px<br>
     * [lg] font-size: 16px, height: 40px<br>
     * [md] font-size: 14px, height: 34px<br>
     * [sm] font-size: 12px, height: 30px
     */
    size: PropTypes.oneOf(['xl', 'lg', 'md', 'sm']),
    /**
     * button タグの type 属性
     */
    type: PropTypes.oneOf(['button', 'submit']),
    /**
     * <a href='https://appkit.pwc.com/appkit4/content/icons?version=react'>アイコン一覧</a>から選択
     */
    icon: PropTypes.string,
    /**
     * width
     */
    width: PropTypes.string,
    /**
     * グレースタイルの場合は true
     */
    isGray: PropTypes.bool,
    /**
     * 活性 / 非活性
     */
    disabled: PropTypes.bool,
    /**
     * クリックハンドラー<br>
     * (event: React.SyntheticEvent) => void
     */
    onClick: PropTypes.func,
    /**
     * スタイル変更用のクラス名
     */
    className: PropTypes.any
}

Button.defaultProps = {
    kind: 'primary',
    type: 'button',
    size: 'md',
    width: 'auto'
}
